function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#5stars_svg__clip0_1_17)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 12.282l-4.945 2.935L4.32 9.608 0 5.813l5.725-.531L8 0l2.274 5.282L16 5.813l-4.32 3.795 1.265 5.61L8 12.281zm.005-.474c1.556 0 2.537-.828 2.537-2.124 0-1.206-.918-1.953-1.934-1.953-.532 0-1 .198-1.288.477V7.047h2.809v-1.35H5.773v3.546l1.07.261c.333-.315.712-.45 1.188-.45.621 0 .936.288.936.693 0 .369-.324.693-.98.693a2.322 2.322 0 01-1.558-.585l-.846 1.08c.558.549 1.36.873 2.421.873z",
  fill: "currentColor"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "5stars_svg__clip0_1_17"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})));

function Svg5Stars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default Svg5Stars;